import React from 'react';
import { createRoot } from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import App from './App';
import { beforeSend } from './posthogScrub';
import './web.css';

const posthogToken = window.__MT && window.__MT.posthogToken;
if (posthogToken) {
  // before_send strips ?phone= from every URL property (#351); saved cards and
  // the card form are marked ph-no-capture in Checkout.jsx.
  posthog.init(posthogToken, { api_host: '/mtx', ui_host: 'https://us.posthog.com', person_profiles: 'identified_only', before_send: beforeSend });

  // Tag our own /api + /ipn calls with the PostHog session + distinct id so
  // server logs (lib/posthogLogs.js) link to this user's Session Replay.
  // Same-origin relative URLs only — never leak ids to third parties.
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    try {
      const url = typeof input === 'string' ? input : input && input.url;
      if (typeof url === 'string' && /^\/(api|ipn)\//.test(url)) {
        const headers = new Headers((init && init.headers) || (typeof input !== 'string' && input.headers) || {});
        const sid = posthog.get_session_id();
        if (sid) headers.set('X-PostHog-Session-Id', sid);
        headers.set('X-PostHog-Distinct-Id', posthog.get_distinct_id());
        return nativeFetch(input, { ...init, headers });
      }
    } catch (e) {
      // fall through to the untouched request
    }
    return nativeFetch(input, init);
  };
}

createRoot(document.getElementById('root')).render(
  posthogToken
    ? <PostHogProvider client={posthog}><App /></PostHogProvider>
    : <App />
);
